export const SET_QUIZ_SETS = 'SET_QUIZ_SETS'
export const SET_QUIZ_SET = 'SET_QUIZ_SET'
export const SET_QUIZ_ID = 'SET_QUIZ_ID'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_ACTIVE_QUESTION = 'SET_ACTIVE_QUESTION'
export const RESET_STATE = 'RESET_STATE'
